import {
    ActionCreatorProps,
    createAction,
    props
} from '@ngrx/store';
import {
    DatiqAnalyticsInputInteraction,
    IDatiqAnalyticsEvent,
} from '@dat/datiq-core/models';

const createActionName: (name: string) => string = (name: string) => {
    return `[Datiq Graph] ${name}`;
};
const defaultProp: ActionCreatorProps<IDatiqAnalyticsEvent> =
    props<IDatiqAnalyticsEvent>();
export const loadTooltipName: (name: string) => string = (name: string) =>
    createActionName(name);

export const loadTooltip = createAction(
    loadTooltipName(`Tooltip ${DatiqAnalyticsInputInteraction.Load}`),
    defaultProp
);
